<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Tracking shows my book was returned because of a delivery issue</h1>
		<div v-if="!shipped">
			<p class="h-text-2">
				The item has not yet shipped, when it does you will be sent tracking.
			</p>
			<email-form
					caption="Email us"
					subject="Tell me when my item will ship"
					body="My item has not yet shipped, can you tell me when it will ship?"
					on-success-url="/help?#/submitted"
					edit-body
					:payload="{ order_line_id }"
					destination-key="cs"
			></email-form>
		</div>
        <div v-else-if="submitted">
            <p class="h-text-2 text-center">
                We have submitted a request for a replacement copy to be sent to you.
            </p>
        </div>
		<div v-else>
			<div v-if="condition !== 'marketplace'">
				<div>
					<v-checkbox label="Use different address" v-model="different_address"></v-checkbox>
					<address-form caption="Alternative Address" v-model="alternative_address" v-if="different_address"></address-form>

					<v-btn color="#7DADED" large round dark class="mb-3" @click="validate" :loading="loading">Request a replacement</v-btn>
				</div>
			</div>
			<div v-else>
				<p>
					Please <a :href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">message your
					seller</a>
					and let them know there was an issue
				</p>

				<p v-if="!spoke_to_seller">
					<v-btn @click="spoke_to_seller = true">I already messaged the seller and got no response</v-btn>
				</p>

				<email-form
						caption="Contact Us"
						v-if="spoke_to_seller"
						subject="Tracking shows my marketplace book was returned because of a delivery issue"
						body="I already messaged the seller and got no response"
						on-success-url="/help?#/submitted"
						edit-body
						:payload="{ order_line_id }"
						destination-key="cs"
				></email-form>

			</div>

		</div>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../../components/BaseNavLinks';
	import AddressForm from './../../../components/AddressForm';
	import Axios from 'axios';
	import EmailForm from './../../../components/EmailForm';

	export default {
		name: "TrackingSaysReturned",

		components: {
			BaseNavLinks,
			AddressForm,
			EmailForm,
		},

		data() {
			return {
				loading: false,
				different_address: false,
				alternative_address: {},
				order_line_id: null,
				condition: null,
				spoke_to_seller: false,
				shipped: false,
                submitted: false
			};
		},

		methods: {
			validate() {
				if (this.different_address) {
					this.$eventHub.$emit('AddressForm');
					if (!this.alternative_address.valid) {
						return;
					}
				}
				this.requestReplacement();
			},

			requestReplacement() {
				const self = this;
				self.loading = true;

				Axios.post('/service/customer_help/rest/index.php/customer_help/send_book_replacement_cs_request/', {
					order_line_id: parseInt(self.$route.params.id),
					alt_addr: self.alternative_address,
				})
					.then(function (response) {
						if (response.status === 200 && response.data && response.data['status'] === 'success') {
                            self.submitted = true;
						}
					})
					.finally(function () {
						self.loading = false;
					});
			}
		},

		mounted() {
			const self = this;
			self.loading = true;
			self.order_line_id = parseInt(self.$route.params.id);

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						self.condition = response.data['data']['product_type'];
						self.shipped = parseInt(response.data['data']['shipped']) > 0;
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},

		watch: {
			alternative_address: function () {
				this.loading = !!this.alternative_address.loading;
				if (!!this.alternative_address.watcher) {
					this.validate();
				}
			},
		},
	}
</script>

<style scoped>

</style>